module.exports = __webpack_public_path__ + "img/9c3db04e978a51976659bae0bf3fa177.svg";